import { chatTypes } from "redux/Ldb/types";

const initialState = {
    creatingConversation: false,
    createConversationSuccess: null,
    createConversationFailure: null,
    fetchingConversation: false,
    fetchConversationSuccess: null,
    fetchConversationFailure: null,
    fetchingAllConversations: false,
    fetchAllConversationsSuccess: null,
    fetchAllConversationsFailure: null,
    sendingAiMessage: false,
    sendAiMessageSuccess: null,
    sendAiMessageFailure: null,
    updatingChatData: false,
    updateChatDataSuccess: null,
    updateChatDataFailure: null,
    fetchingChatThread: true,
    fetchChatThreadSuccess: null,
    fetchChatThreadFailure: null,
    updatingConversation: false,
    updateConversationSuccess: null,
    updateConversationFailure: null,
    creatingForecast: false,
    createForecastSuccess: null,
    createForecastFailure: null,
    deletingConversation: false,
    deleteConversationSuccess: null,
    deleteConversationFailure: null,
    gettingSalesTargetForecast: false,
    getSalesTargetForecastSuccess: null,
    getSalesTargetForecastFailure: null,
    savingTargetForecast: false,
    saveTargetForecastSuccess: null,
    saveTargetForecastFailure: null,
    agentType: "synth-gpt",
};

export const chat = (state = initialState, action: { type: string; payload: any }) => {
    switch (action.type) {
        case chatTypes.FETCH_ALL_CONVERSATIONS_REQUEST:
            return {
                ...state,
                fetchingAllConversations: true,
                fetchAllConversationsSuccess: null,
                fetchAllConversationsFailure: null,
            };
        case chatTypes.FETCH_ALL_CONVERSATIONS_SUCCESS:
            return {
                ...state,
                fetchingAllConversations: false,
                fetchAllConversationsSuccess: action.payload,
                fetchAllConversationsFailure: null,
            };
        case chatTypes.FETCH_ALL_CONVERSATIONS_FAILURE:
            return {
                ...state,
                fetchingAllConversations: false,
                fetchAllConversationsSuccess: null,
                fetchAllConversationsFailure: action.payload,
            };

        case chatTypes.CREATE_CONVERSATION_REQUEST:
            return {
                ...state,
                creatingConversation: true,
                createConversationSuccess: null,
                createConversationFailure: null,
            };
        case chatTypes.CREATE_CONVERSATION_SUCCESS:
            return {
                ...state,
                creatingConversation: false,
                createConversationSuccess: action.payload,
                createConversationFailure: null,
            };
        case chatTypes.CREATE_CONVERSATION_FAILURE:
            return {
                ...state,
                creatingConversation: false,
                createConversationSuccess: null,
                createConversationFailure: action.payload,
            };

        case chatTypes.FETCH_CONVERSATION_REQUEST:
            return {
                ...state,
                fetchingConversation: true,
                fetchConversationSuccess: null,
                fetchConversationFailure: null,
            };
        case chatTypes.FETCH_CONVERSATION_SUCCESS:
            return {
                ...state,
                fetchingConversation: false,
                fetchConversationSuccess: action.payload,
                fetchConversationFailure: null,
            };
        case chatTypes.FETCH_CONVERSATION_FAILURE:
            return {
                ...state,
                fetchingConversation: false,
                fetchConversationSuccess: null,
                fetchConversationFailure: action.payload,
            };

        case chatTypes.SEND_AI_CHAT_REQUEST:
            return {
                ...state,
                sendingAiMessage: true,
                sendAiMessageSuccess: null,
                sendAiMessageFailure: null,
            };
        case chatTypes.SEND_AI_CHAT_SUCCESS:
            return {
                ...state,
                sendingAiMessage: false,
                sendAiMessageSuccess: action.payload,
                sendAiMessageFailure: null,
            };
        case chatTypes.SEND_AI_CHAT_FAILURE:
            return {
                ...state,
                sendingAiMessage: false,
                sendAiMessageSuccess: null,
                sendAiMessageFailure: action.payload,
            };

        case chatTypes.UPDATE_CHAT_DATA_REQUEST:
            return {
                ...state,
                updatingChatData: true,
                updateChatDataSuccess: null,
                updateChatDataFailure: null,
            };
        case chatTypes.UPDATE_CHAT_DATA_SUCCESS:
            return {
                ...state,
                updatingChatData: false,
                updateChatDataSuccess: action.payload,
                updateChatDataFailure: null,
            };
        case chatTypes.UPDATE_CHAT_DATA_FAILURE:
            return {
                ...state,
                updatingChatData: false,
                updateChatDataSuccess: null,
                updateChatDataFailure: action.payload,
            };
        case chatTypes.FETCH_CHAT_THREAD_REQUEST:
            return {
                ...state,
                fetchingChatThread: true,
                fetchChatThreadSuccess: null,
                fetchChatThreadFailure: null,
            };
        case chatTypes.FETCH_CHAT_THREAD_SUCCESS:
            return {
                ...state,
                fetchingChatThread: false,
                fetchChatThreadSuccess: action.payload,
                fetchChatThreadFailure: null,
            };
        case chatTypes.FETCH_CHAT_THREAD_FAILURE:
            return {
                ...state,
                fetchingChatThread: false,
                fetchChatThreadSuccess: null,
                fetchChatThreadFailure: action.payload,
            };
        case chatTypes.UPDATE_CONVERSATION_REQUEST:
            return {
                ...state,
                updatingConversation: true,
                updateConversationSuccess: null,
                updateConversationFailure: null,
            };
        case chatTypes.UPDATE_CONVERSATION_SUCCESS:
            return {
                ...state,
                updatingConversation: false,
                updateConversationSuccess: action.payload,
                updateConversationFailure: null,
            };
        case chatTypes.UPDATE_CONVERSATION_FAILURE:
            return {
                ...state,
                updatingConversation: false,
                updateConversationSuccess: null,
                updateConversationFailure: action.payload,
            };
        case chatTypes.CREATE_FORECAST_REQUEST:
            return {
                ...state,
                creatingForecast: true,
                createForecastSuccess: null,
                createForecastFailure: null,
            };
        case chatTypes.CREATE_FORECAST_SUCCESS:
            return {
                ...state,
                creatingForecast: false,
                createForecastSuccess: action.payload,
                createForecastFailure: null,
            };
        case chatTypes.CREATE_FORECAST_FAILURE:
            return {
                ...state,
                creatingForecast: false,
                createForecastSuccess: null,
                createForecastFailure: action.payload,
            };
        case chatTypes.DELETE_CONVERSATION_REQUEST:
            return {
                ...state,
                deletingConversation: true,
                deleteConversationSuccess: null,
                deleteConversationFailure: null,
            };
        case chatTypes.DELETE_CONVERSATION_SUCCESS:
            return {
                ...state,
                deletingConversation: false,
                deleteConversationSuccess: action.payload,
                deleteConversationFailure: null,
            };
        case chatTypes.DELETE_CONVERSATION_FAILURE:
            return {
                ...state,
                deletingConversation: false,
                deleteConversationSuccess: null,
                deleteConversationFailure: action.payload,
            };
        case chatTypes.GET_SALES_TARGET_FORECAST_REQUEST:
            return {
                ...state,
                gettingSalesTargetForecast: true,
                getSalesTargetForecastSuccess: null,
                getSalesTargetForecastFailure: null,
            };
        case chatTypes.GET_SALES_TARGET_FORECAST_SUCCESS:
            return {
                ...state,
                gettingSalesTargetForecast: false,
                getSalesTargetForecastSuccess: action.payload,
                getSalesTargetForecastFailure: null,
            };
        case chatTypes.GET_SALES_TARGET_FORECAST_FAILURE:
            return {
                ...state,
                gettingSalesTargetForecast: false,
                getSalesTargetForecastSuccess: null,
                getSalesTargetForecastFailure: action.payload,
            };
        case chatTypes.SAVE_TARGET_FORECAST_REQUEST:
            return {
                ...state,
                savingTargetForecast: true,
                saveTargetForecastSuccess: null,
                saveTargetForecastFailure: null,
            };
        case chatTypes.SAVE_TARGET_FORECAST_SUCCESS:
            return {
                ...state,
                savingTargetForecast: false,
                saveTargetForecastSuccess: action.payload,
                saveTargetForecastFailure: null,
            };
        case chatTypes.SAVE_TARGET_FORECAST_FAILURE:
            return {
                ...state,
                savingTargetForecast: false,
                saveTargetForecastSuccess: null,
                saveTargetForecastFailure: action.payload,
            };
        case chatTypes.UPDATE_AGENT_TYPE:
            return {
                ...state,
                agentType: action.payload,
            };
        default:
            return state;
    }
};
